import { Component, OnInit, Input } from '@angular/core';
import { OptionType, OrderDuration, OrderType, Quote, TransactionType, OptionStrategy } from './../../../../models/common/trading-common.model';
import { TradingEntitlements } from './../../../../models/common/trading-entitlements';
import { TradingService } from '../../../../services/common/trading-service.service';
import { getValueOrEmptyString } from '../../../../utils/trading-common';
@Component({
  selector: 'cancel-options-order-details',
  templateUrl: './cancel-options-order-details.component.html',
  styleUrls: ['./cancel-options-order-details.component.css']
})
export class CancelOptionsOrderDetailsComponent implements OnInit {
  @Input() order: any;
  // @Input() nonDollarTrade: boolean;
  @Input() tradingEntitlements: TradingEntitlements;
  @Input() isBdUser: boolean;
  @Input() isRiaUser: boolean;
  @Input() isDualUser: boolean;
  @Input() isComplexOption: boolean;
  @Input() isAPA: boolean;

  orderTitleStyle: string = 'tr-OrderSubTitle_Buy';
  marketOrder: boolean;
  gtdOrder: boolean;
  // showLocation: boolean;
  // shortSaleExemptOrder: boolean;
  sellShortOrder: boolean;
  accountType: string;
  expirationDate: Date;
  strikePrice: string;

  showAdditionalInfo: boolean = false;
  showIpSplitCommission: boolean = false;
  showRegulatoryInfo: boolean = false;
  showExecutionPrice: boolean = false;
  showSolicited: boolean = false;
  showOrderQualifer: boolean;
  isPartialOrder: boolean = false;
  activeTheme: string;
  formTranType: string;
  contractsLabel: string;

  constructor(private tradingService: TradingService) { }

  ngOnInit() {
    this.activeTheme = this.tradingService.getActiveThemeFromCurrentContainer();
    this.setValuesFromSymId();
    this.setCoreSectionData();
    this.setAdditionalInfoSectionData();
    this.setIPSplitSectionData();
    this.setRegulatoryInfoData();
    this.setShowSolicited();

    const orderStatus = (this.order.status || '').toString().trim();
    if (orderStatus === 'PART_EXECUTED' || orderStatus === 'PART_MIXED' || orderStatus === 'PART_CANCELED') {
      this.isPartialOrder = true;
    }
    this.setContractsLabel();
    // To handle dirty API data, such as: [null]
    this.showOrderQualifer = !!this.order.addlOrdData && this.order.addlOrdData.filter(n => n).length > 0;
  }

  private setShowSolicited(): void {
    if (this.isDualUser) {
      this.showSolicited = false;
    } else if (this.isBdUser) {
      this.showSolicited = true;
    } else if (this.isRiaUser && this.order.account.ibdId === 'C01' && this.order.account.acctProdtProfileCd === 'PMAS') {
      this.showSolicited = true;
    } else if (this.tradingEntitlements.isRetailUser) {
      this.showSolicited = this.tradingEntitlements.isSolicitedEnabled || this.tradingEntitlements.isNonSolicitedEnabled;
    }
  }

  private setContractsLabel(): void {
    if (this.order.strategy === OptionStrategy.BUY_WRITE || this.order.strategy === OptionStrategy.MARRIED_PUT) {
      this.contractsLabel = this.isPartialOrder ? 'labels.originalquantity' : 'labels.ordQty';
    }
    else {
      this.contractsLabel = this.isPartialOrder ? 'labels.optionCore.originalContracts' : 'labels.optionCore.contracts';
    }
  }

  setCoreSectionData() {
    // For core section
    if (this.order.transactionType === TransactionType.BUY) {
      this.orderTitleStyle = 'tr-OrderSubTitle_Buy';
    } else {
      this.orderTitleStyle = 'tr-OrderSubTitle_Sell';
    }
    this.gtdOrder = (this.order.duration === OrderDuration.GTD);
    this.setOrderTypeAndDurationForRetail();

    // Can't directly set the order's transaction type into the form, due to the submitted values not matching the
    // generalized values in the form. Need to derive the correct type for the form when the order has a non-null value.

    if (!this.isComplexOption) {
      this.setformTranType();
    } else {
      this.setOptionLegTransactionType();

    }
  }

  private setOrderTypeAndDurationForRetail(): void {
    if (this.tradingEntitlements.isRetailUser) {
      if (this.order.orderType === OrderType.LIMIT && this.order.additionalInfoAon === 'All or None') {
        this.order.orderType = OrderType.AON;
      } else if (this.order.orderType === OrderType.LIMIT && this.order.duration === OrderDuration.FOK) {
        this.order.orderType = OrderType.FOK;
        this.order.duration = OrderDuration.DAY;
      }
    }
  }

  private setformTranType(): void {
    if (!!this.order.transactionType) {
      const tranType = this.order.transactionType;
      const openCloseInd = getValueOrEmptyString(this.order.netxOpnClsInd).trim().toUpperCase();
	    const optionType = this.order.optionType.toUpperCase();
      this.formTranType = this.getFormTranType(this.formTranType, openCloseInd, tranType, optionType);
    }
  }

  private isSellCoveredCallOrWriteCoveredCall(): boolean {
    let isCovered = !!this.order.dvpRvpNmeAddrTxt1 ? this.order.dvpRvpNmeAddrTxt1.trim() : '';
    return !!isCovered && (isCovered === 'SELL COVERED CALL' || isCovered === 'WRITE COVERED CALL');
  }

  private getFormTranTypeForBuy(formTranType: any, openCloseInd: string, optionType: any): any {
    if (optionType === OptionType.CALL) {
      if (openCloseInd === 'OPEN') {
        formTranType = TransactionType.BUY_CALL_TO_OPEN;
      } else if (openCloseInd === 'CLOSE') {
        formTranType = TransactionType.BUY_CALL_TO_CLOSE;
      }
    } else if (optionType === OptionType.PUT) {
      if (openCloseInd === 'OPEN') {
        formTranType = TransactionType.BUY_PUT_TO_OPEN;
      } else if (openCloseInd === 'CLOSE') {
        formTranType = TransactionType.BUY_PUT_TO_CLOSE;
      }
    }
    return formTranType;
  }

  private getFormTranTypeForSellFromPortfolio(formTranType: any, openCloseInd: string, optionType: any): any {
    if (openCloseInd === 'OPEN') {
      if (this.isSellCoveredCallOrWriteCoveredCall()) {
        formTranType = TransactionType.SELL_COVERED_CALLS;
      } else if (optionType === OptionType.CALL) {
        formTranType = TransactionType.SELL_CALL_TO_OPEN;
      } else if (optionType === OptionType.PUT) {
        formTranType = TransactionType.SELL_PUT_TO_OPEN;
      }
    } else if (openCloseInd === 'CLOSE') {
      if (optionType === OptionType.CALL) {
        formTranType = TransactionType.CLOSE_EXISTING_CALL;
      } else if (optionType === OptionType.PUT) {
        formTranType = TransactionType.CLOSE_EXISTING_PUT;
      }
    }
    return formTranType;
  }

  private getFormTranType(formTranType: any, openCloseInd: string, tranType: any, optionType: any): any {

    if (tranType === TransactionType.BUY) {
      return this.getFormTranTypeForBuy(formTranType, openCloseInd, optionType);
    } else if (tranType === TransactionType.SELL_FROM_PORTFOLIO) {
      return this.getFormTranTypeForSellFromPortfolio(formTranType, openCloseInd, optionType);
    }
    return formTranType;
  }

  private setOptionLegTransactionType(): void {
    // derive correct transaction type for each leg
    for (let optionLeg of this.order.optionLegList) {
      if (!!optionLeg.transactionType) {
        const tranType = optionLeg.transactionType;
        let openCloseInd = getValueOrEmptyString(optionLeg.netxOpnClsInd).trim().toUpperCase();
        let callOrPutCd = this.getCallOrPutCd(optionLeg);
        optionLeg.transactionType = this.getFormTranType(optionLeg.transactionType, openCloseInd, tranType, callOrPutCd);
      }
    }
  }

  private getCallOrPutCd(optionLeg:any): any{
    // Unlike non-complex options, the option legs use their quote's call/put indicator.
        // But if the symbol is no longer valid (e.g., expired), need to derive the indicator from the symbol.
        const optionQuote: Quote = optionLeg.quote as Quote;
        let optSymId: string = !!optionQuote.symId ? optionQuote.symId : '';
        let callOrPutCd = getValueOrEmptyString(optionQuote.callOrPutCd).trim().toUpperCase();
        
    if (callOrPutCd === '' || (callOrPutCd !== OptionType.CALL && callOrPutCd !== OptionType.PUT)) {
      // Symbol is apparently no longer a valid option, let's derive the call/put indicator from the symbol.
      // But if even the symbol doesn't have a standard call or put indicator in it, we'll just give up and set it to blank,
      // and leave the transaction type as whatever was sent from the back-end (following if checks will all fail).
      callOrPutCd = optSymId.indexOf(' C ') > 0 ? OptionType.CALL : optSymId.indexOf(' P ') > 0 ? OptionType.PUT : '';
    }
    return callOrPutCd;
  }

  setAdditionalInfoSectionData() {
    // For additional-info section
    this.showAdditionalInfo = ((!!this.order.addlOrdData && this.order.addlOrdData.length > 0) ||
                                (this.isBdUser && !!this.order.discExercised?.trim()) || (this.isBdUser && !!this.order.addlIbdMemo) || this.order.trailer ||
                                (this.isBdUser && this.tradingEntitlements.isSourceOfInputOverrideEnabled && !!this.order.sourceOverride));
  }

  setIPSplitSectionData() {
    if (!!this.order.commission) {
      this.showIpSplitCommission = (!!this.order.commission.splitIP1 || !!this.order.commission.groupId);
    }
  }

  setRegulatoryInfoData() {
    this.showRegulatoryInfo = !this.isRiaUser && (!!(this.order.secIbdOrdRcvDate || '').trim() ||
      !!(this.order.secTermsAndConditions || '').trim() ||
      !!(this.order.secIbdOrdRcvFromName || '').trim() ||
      !!(this.order.oatsDeskReceiptDate1 || '').trim() ||
      !!(this.order.oatsDeskTypeCode1 || '').trim() ||
      !!(this.order.ordXctnTxt1 || '').trim() ||
      !!(this.order.oatsDeskReceiptDate2 || '').trim() ||
      !!(this.order.oatsDeskTypeCode2 || '').trim() ||
      !!(this.order.ordXctnTxt2 || '').trim());
  }

  formatBackendDate(sourceDate: string): string {     // yyyymmdd => mm/dd/yyyy
    if (!!sourceDate) {
        return sourceDate.substring(4, 6) + '/' + sourceDate.substring(6, 8) + '/' + sourceDate.substring(0, 4);
    } else {
        return '';
    }
  }

  formatBackendTime(sourceTime: string): string {
    if ( !!sourceTime && sourceTime !== '' ) {
        return sourceTime.substring(0, 2) + ':' + sourceTime.substring(2, 4) + ':' + sourceTime.substring(4);
    } else {
        return sourceTime;
    }
  }

  setValuesFromSymId() {
    if (this.order.quote && this.order.quote.symId) {
      const valArray = this.order.quote.symId.split(' ');
      let dateStr = valArray[1];
      let strikePrice = valArray[3];
      if (dateStr) {
        this.expirationDate = new Date(dateStr.substr(4, 4), dateStr.substr(0, 2) - 1, dateStr.substr(2, 2));
      }
      if (strikePrice) {
        this.strikePrice = strikePrice;
      }
    }
  }

  getTransactionTypeString(transaction): string {
      if (this.isAPA) {
          if (transaction === 'BUY_CALL_TO_CLOSE' || transaction === 'BUY_PUT_TO_CLOSE' 
              || transaction === 'CLOSE_EXISTING_CALL' || transaction === 'CLOSE_EXISTING_PUT') {
              return transaction + '_NOT_IN_ACCOUNT';
          } 
      }

      return transaction;
  }
}
